export const aboutData = {
  brandName: "虚空韩漫网",
  slogan: "开启属于你的韩漫世界",
  introduction: `虚空韩漫网成立于2022年，是国内领先的韩漫在线免费阅读平台之一。我们致力于为中国韩漫爱好者提供最优质、最流畅的韩漫免费漫画在线观看体验。平台采用创新的下拉式免费阅读方式，让读者无需翻页即可沉浸于韩漫的精彩世界中。

我们的团队由一群热爱韩漫文化的年轻人组成，每天精心筛选来自韩国的优质漫画作品，并进行专业的本地化翻译和排版，确保每一位读者都能享受到原汁原味的韩漫阅读体验。

从恋爱甜宠到热血奇幻，从悬疑惊悚到温馨日常，虚空韩漫网拥有丰富的漫画品类，满足不同读者的阅读需求。我们与多家韩国漫画工作室建立了长期合作关系，确保内容的正版授权和持续更新。`,
  vision: "成为中国韩漫爱好者最信赖的在线阅读平台，让每一个热爱韩漫的人都能在这里找到属于自己的故事。",
  features: [
    {
      icon: "ri-phone-find-line",
      title: "正版授权",
      description: "与韩国多家漫画工作室达成正版合作，确保平台所有内容均有合法授权，让读者安心阅读。",
    },
    {
      icon: "ri-file-text-line",
      title: "丰富品类",
      description: "涵盖恋爱、奇幻、动作、搞笑、悬疑、剧情、日常等七大品类，数万部精品韩漫持续更新中。",
    },
    {
      icon: "ri-arrow-down-line",
      title: "下拉式阅读",
      description: "创新的下拉式免费阅读方式，告别传统翻页，一气呵成享受流畅阅读体验。",
    },
    {
      icon: "ri-smartphone-line",
      title: "多端适配",
      description: "全面支持电脑端和手机端访问，随时随地畅享韩漫阅读乐趣，云端同步阅读进度。",
    },
    {
      icon: "ri-translate-2",
      title: "专业翻译",
      description: "资深韩语翻译团队精心打磨每一句对白，确保翻译质量，还原漫画原汁原味的情感表达。",
    },
    {
      icon: "ri-timer-flash-line",
      title: "极速更新",
      description: "韩国最新漫画同步上线，热门作品保持每日更新，让读者永远追在最前线。",
    },
  ],
  stats: [
    { label: "累计用户", value: "580万+" },
    { label: "收录漫画", value: "12,000+部" },
    { label: "日更新量", value: "200+话" },
    { label: "合作画师", value: "800+位" },
  ],
  reviews: [
    {
      name: "漫迷小王",
      avatar: "https://readdy.ai/api/search-image?query=young%20asian%20male%20portrait%20avatar%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20background&width=64&height=64&seq=avatar-1&orientation=squarish",
      rating: 5,
      content: "虚空韩漫网真的是我用过最好的韩漫阅读平台！下拉式阅读太舒服了，再也不用像以前一样点来点去翻页。而且更新速度超级快，追更体验一流。",
      date: "2026-07-28",
    },
    {
      name: "甜甜的漫画少女",
      avatar: "https://readdy.ai/api/search-image?query=young%20asian%20female%20portrait%20avatar%2C%20cute%20smile%2C%20casual%20style%2C%20clean%20background&width=64&height=64&seq=avatar-2&orientation=squarish",
      rating: 5,
      content: "从朋友推荐来的，一下子就被吸引住了！漫画种类特别全，不管想看什么类型都能找到。翻译质量也很高，能感受到翻译团队的用心。",
      date: "2026-07-25",
    },
    {
      name: "深夜追漫人",
      avatar: "https://readdy.ai/api/search-image?query=young%20asian%20male%20portrait%20avatar%2C%20serious%20expression%2C%20dark%20hair%2C%20clean%20background&width=64&height=64&seq=avatar-3&orientation=squarish",
      rating: 5,
      content: "作为一个重度韩漫爱好者，我几乎把所有韩漫平台都试过了。虚空韩漫网的阅读体验是最流畅的，下拉式的设计真的很赞。界面也很简洁，没有烦人的广告弹窗。",
      date: "2026-07-20",
    },
    {
      name: "小确幸的日常",
      avatar: "https://readdy.ai/api/search-image?query=young%20asian%20female%20portrait%20avatar%2C%20warm%20smile%2C%20long%20hair%2C%20clean%20background&width=64&height=64&seq=avatar-4&orientation=squarish",
      rating: 4,
      content: "日常和恋爱类的漫画特别多，画风也都很精美。希望以后可以增加更多完结作品，有些追了好久的漫画想要一口气看完。总体体验非常好！",
      date: "2026-07-18",
    },
  ],
  contactInfo: {
    email: "contact@xukongmanhua.com",
    wechat: "虚空韩漫网",
    weibo: "@虚空韩漫网官方",
    qq: "800123456",
    workingHours: "周一至周五 9:00-18:00",
    address: "中国浙江省杭州市余杭区未来科技城",
  },
};

export const faqData = [
  {
    question: "虚空韩漫网上的漫画都是免费的吗？",
    answer: "是的！虚空韩漫网上的所有韩漫均为免费在线观看。我们始终坚持免费模式，让每一位韩漫爱好者都能无障碍地享受优质的漫画内容。部分最新连载可能需要注册会员后阅读。",
  },
  {
    question: "什么是下拉式免费阅读？",
    answer: "下拉式免费阅读是虚空韩漫网独创的阅读模式。传统漫画需要点击翻页，而下拉式阅读将整话内容纵向排列，读者只需向下滚动即可流畅阅读，获得更加沉浸式的阅读体验。这种方式特别适合手机端阅读。",
  },
  {
    question: "漫画的更新频率是怎样的？",
    answer: "热门连载漫画通常保持每周一更的节奏，部分人气作品可达到每周两更。当韩国原版更新后，我们的翻译团队会在24-48小时内完成本地化处理并上线。建议关注喜欢的漫画，第一时间获取更新通知。",
  },
  {
    question: "如何找到我想看的漫画类型？",
    answer: "您可以通过首页的分类导航进入不同品类的漫画列表。我们目前有恋爱、奇幻、动作、搞笑、悬疑、剧情、日常等七大品类。此外，首页的热门推荐和最新上架栏目也能帮助您发现优质作品。",
  },
  {
    question: "网站是否支持手机端访问？",
    answer: "完全支持！虚空韩漫网采用响应式设计，在手机、平板和电脑上都可以获得出色的阅读体验。下拉式阅读在手机端尤其方便，单手即可轻松浏览漫画内容。",
  },
  {
    question: "漫画内容是否有版权？",
    answer: "虚空韩漫网高度重视版权保护。平台上的所有漫画内容均获得韩国原作方的正版授权。我们与多家韩国漫画工作室保持长期合作，确保内容的合法性和持续性。",
  },
  {
    question: "遇到阅读问题怎么办？",
    answer: "如果您在阅读过程中遇到任何问题（如图片加载失败、页面显示异常等），请尝试刷新页面或清除浏览器缓存。如问题持续存在，欢迎通过邮箱（contact@xukongmanhua.com）联系我们，我们会在工作时间内尽快回复。",
  },
];